import * as React from "react";
import { Box, IconButton } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

type Props = {
  instagram?: string;
  whatsapp?: string;
  color?: string;
  size?: "small" | "medium";
  gap?: number;
  className?: string;
  style?: React.CSSProperties;
};

const SocialLinks = ({
  instagram,
  whatsapp,
  color = "currentColor",
  size = "small",
  gap = 8,
  className,
  style,
}: Props) => {
  // If nothing to show, render nothing
  if (!instagram && !whatsapp) return null;

  return (
    <Box
      className={className}
      style={{ display: "flex", alignItems: "center", gap, ...style }}
    >
      {instagram && (
        <IconButton
          aria-label="Instagram"
          size={size}
          component="a"
          href={instagram}
          target="_blank"
          rel="noreferrer"
          sx={{
            color,
            opacity: 0.85,
            "&:hover": { opacity: 1, backgroundColor: "#ffffff10" },
          }}
        >
          <InstagramIcon fontSize={size === "small" ? "small" : "medium"} />
        </IconButton>
      )}

      {whatsapp && (
        <IconButton
          aria-label="WhatsApp"
          size={size}
          component="a"
          href={whatsapp}
          target="_blank"
          rel="noreferrer"
          sx={{
            color,
            opacity: 0.85,
            "&:hover": { opacity: 1, backgroundColor: "#ffffff10" },
          }}
        >
          <WhatsAppIcon fontSize={size === "small" ? "small" : "medium"} />
        </IconButton>
      )}
    </Box>
  );
};

export default SocialLinks;
